export default "<ion-app>\r\n  <ion-router-outlet id=\"main-content\"></ion-router-outlet>\r\n</ion-app>\r\n";